import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { School } from "../models/school.model";
import { SchoolAddModel } from "../models/school-add-model";
import { SchoolResponse } from "../models/school-response.model";
import { SchoolManagement } from "../models/school-management.model";
import { SchoolMonitorResponse } from "../models/school-monitor.model";
import { FormGroup } from "@angular/forms";

export namespace SchoolActions {

  @logDispatcher
  export class GetSchools {
    static readonly type = '[School] GetSchools';
    constructor(public zoneId: number, public profitCenterCode: string, public exerciseId: number, public user: string) {}
  }

  @logDispatcher
  export class GetSchoolsSuccess {
    static readonly type = '[School] GetSchoolsSuccess';
    constructor(public schools: SchoolResponse[]) {}
  }

  @logDispatcher
  export class GetSchoolsMap {
    static readonly type = '[School] GetSchoolsMap';
    constructor(public zoneId: number, public profitCenterCode: string, public exerciseId: number, public user: string, public contractType?: boolean) {}
  }

  @logDispatcher
  export class GetSchoolsMapSuccess {
    static readonly type = '[School] GetSchoolsMapSuccess';
    constructor(public schoolsMap: School[]) {}
  }

  @logDispatcher
  export class GetSchoolDetails {
    static readonly type = '[School] GetSchoolDetails';
    constructor(public schoolId: number, public exerciseId: number) {}
  }

  @logDispatcher
  export class GetSchoolDetailsSuccess {
    static readonly type = '[School] GetSchoolDetailsSuccess';
    constructor(public school: SchoolManagement) {}
  }

  @logDispatcher
  export class GetSchoolsForMonitor {
    static readonly type = '[School] GetSchoolsForMonitor';
    constructor(public exerciseId: number, public user: string) {}
  }

  @logDispatcher
  export class GetSchoolsForMonitorSuccess {
    static readonly type = '[School] GetSchoolsForMonitorSuccess';
    constructor(public response: SchoolMonitorResponse[]) {}
  }

  @logDispatcher
  export class AddSchool {
    static readonly type = '[School] AddSchool';
    constructor(public school: SchoolAddModel, public user: string) {}
  }

  @logDispatcher
  export class AddSchoolSuccess {
    static readonly type = '[School] AddSchoolSuccess';
    constructor(public school: SchoolAddModel, public newSchoolId: number) {}
  }

  @logDispatcher
  export class EditSchool {
    static readonly type = '[School] EditSchool';
    constructor(public schoolForm: FormGroup, public user: string) {}
  }

  @logDispatcher
  export class EditSchoolSuccess {
    static readonly type = '[School] EditSchoolSuccess';
    constructor(public schoolForm: FormGroup) {}
  }

  @logDispatcher
  export class DeleteSchoolService {
    static readonly type = '[School] DeleteSchoolService';
    constructor(public schoolEngagementId: number, public schoolId: number) {}
  }

  @logDispatcher
  export class DeleteSchoolServiceSuccess {
    static readonly type = '[School] DeleteSchoolServiceSuccess';
    constructor(public schoolEngagementId: number) {}
  }

  @logDispatcher
  export class SetSchoolsDefaultState  {
      static readonly type = '[School] SetSchoolsDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetSchoolAddFormDefaultState  {
      static readonly type = '[School] SetSchoolAddFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetSchoolFormDefaultState  {
      static readonly type = '[School] SetSchoolFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[School] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetFilterCurrentExercise {
    static readonly type = '[School] SetFilterCurrentExercise';
    constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class SetIsEdited {
    static readonly type = '[School] SetIsEdited';
    constructor(public isEdited: boolean) {}
  }

  @logDispatcher
  export class SetIsSubmitted {
    static readonly type = '[School] SetIsSubmitted';
    constructor(public isSubmitted: boolean) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[School] Error';
    constructor(public error: any) {}
  }
}
